module.exports = "SELECT * FROM layer_spec\n"